import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { guestAccessEntrypoint } from '@atlassian/jira-spa-apps-products-jsw-guest-access/entrypoint.tsx';

export const guestAccessPageEntrypoint = createPageEntryPoint({
	main: guestAccessEntrypoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});

export default guestAccessPageEntrypoint;
